import { createItemsData } from '../utils/request.utils'
import { Service } from './base-service'
import { HALApiService } from './hal-api.service'

export const pickingTasksService = new Service('/storage/tasks/task', HALApiService, createItemsData)
